// Cloud-run destinations only. Add root domains here; subdomains match automatically.
// This is a lightweight abuse guard, not a comprehensive scraping detector.
export const blockedCloudDomains = [
  // Torrent indexes and unofficial software-download destinations.
  // Explicit domains only: do not block legitimate torrent clients or all downloads.
  'yasdl.com', 'soft98.ir', 'downloadha.com', 'patoghu.com',
  'thepiratebay.org', '1337x.to', 'yts.mx', 'eztvx.to',
  'fitgirl-repacks.site', 'dodi-repacks.site',
  // Search and reference
  'google.com', 'google.co.uk', 'google.co.in', 'google.com.ng', 'google.ca',
  'google.com.au', 'google.de', 'google.fr', 'google.co.jp', 'google.com.br', 'google.es',
  'bing.com', 'yahoo.com', 'duckduckgo.com', 'baidu.com', 'yandex.com', 'yandex.ru',
  'wikipedia.org', 'quora.com',
  // Social networks and media
  'reddit.com', 'redd.it', 'facebook.com', 'fb.com', 'instagram.com',
  'threads.net', 'threads.com', 'twitter.com', 'x.com', 't.co', 'linkedin.com',
  'tiktok.com', 'pinterest.com', 'snapchat.com', 'youtube.com', 'youtu.be',
  'twitch.tv', 'discord.com', 'discord.gg', 'telegram.org', 't.me', 'whatsapp.com',
  // Shopping and marketplaces
  'amazon.com', 'amazon.co.uk', 'amazon.ca', 'amazon.de', 'amazon.fr', 'amazon.in',
  'amazon.co.jp', 'amazon.com.au', 'amazon.it', 'amazon.es', 'ebay.com', 'ebay.co.uk', 'etsy.com',
  'walmart.com', 'target.com', 'aliexpress.com', 'alibaba.com', 'temu.com',
  'shein.com', 'craigslist.org', 'facebookmarketplace.com',
  'bestbuy.com', 'costco.com', 'homedepot.com', 'wayfair.com',
  'mercadolibre.com', 'shopee.com', 'lazada.com',
  'jiji.ng', 'jumia.com.ng', 'konga.com', 'propertypro.ng', 'property24.com',
  // Travel, property, jobs and business directories
  'airbnb.com', 'airbnb.co.uk', 'airbnb.ca', 'airbnb.com.au', 'airbnb.fr', 'airbnb.de',
  'booking.com', 'expedia.com', 'tripadvisor.com', 'agoda.com', 'hotels.com',
  'kayak.com', 'skyscanner.net', 'zillow.com', 'realtor.com', 'rightmove.co.uk',
  'zoopla.co.uk', 'indeed.com', 'glassdoor.com', 'yelp.com', 'yellowpages.com',
  'trustpilot.com', 'crunchbase.com',
  'g2.com', 'capterra.com', 'clutch.co', 'zoominfo.com', 'apollo.io',
  'monster.com', 'ziprecruiter.com', 'seek.com.au', 'naukri.com',
  'redfin.com', 'trulia.com', 'apartments.com', 'realtor.ca', 'realestate.com.au',
  'vrbo.com', 'trip.com', 'trivago.com', 'hostelworld.com',
] as const;

export const blockedCloudTargetMessage = 'This website is not supported for cloud runs. Use your own website or app instead.';

export function isBlockedCloudTarget(value: string): boolean {
  try {
    const hostname = new URL(value).hostname.toLowerCase().replace(/\.+$/, '');
    return blockedCloudDomains.some(domain => hostname === domain || hostname.endsWith(`.${domain}`));
  } catch { return false; } // URL validation reports malformed URLs separately.
}
